// @flow

import unifizeUser from "../index";
import picture from "src/components/user/picture/Small";

export default unifizeUser(picture);
